module.exports = __webpack_public_path__ + "img/profile_sp.c4c3cfdc.png";